export function isValid<T>(values: unknown, valid: boolean): values is T {
  return valid
}
